// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { WorkflowTestRequest } from './workflow-test-request';

/** See com.rev360.pms.api.controller.encounter.dynamic.UpdateWorkflowTestsRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateWorkflowTestsRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfProperty({ designType: Number })
	patientId!: number | null;

	@GandalfProperty({ designType: Number })
	templateId!: number | null;

	@GandalfArray(WorkflowTestRequest)
	tests!: WorkflowTestRequest[] | null;

	@GandalfProperty({ designType: Number })
	workflowScreenId!: number | null;

}
